package dev.lingvo.site.pages.app.projects.slug.screenshots

import dev.lingvo.shared.CaptureDto
import dev.lingvo.shared.DeviceClass

/** Captions-only slots reuse the source capture: history follows its locale, not the visible caption. */
fun captureHistoryForCell(captures: List<CaptureDto>, slotId: String, device: DeviceClass?, locale: String): List<CaptureDto> =
    captures.filter { it.slotId == slotId && it.deviceClass == device && it.locale == locale && it.supersededAt != null }
        .sortedByDescending { it.capturedAt }

fun captureReviewAllowed(capture: CaptureDto): Boolean = !capture.blobMissing && capture.supersededAt == null

/** Resolves the visible capture while a post-mutation coverage refresh is pending. */
fun drawerCaptureForCell(
    captures: List<CaptureDto>, slotId: String, device: DeviceClass?, locale: String, coverageCaptureId: String?,
): CaptureDto? {
    val current = captures.filter { it.slotId == slotId && it.deviceClass == device && it.locale == locale && it.supersededAt == null }
    return current.firstOrNull { it.id == coverageCaptureId } ?: current.firstOrNull()
}
